import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { IonPage, IonContent, IonButton, IonText } from '@ionic/react';
import { useRepositories } from '../../infrastructure/http/RepositoryProvider';
import BrandMark from '../components/BrandMark';
import PasswordInput from '../components/PasswordInput';
import './Login.css';

const ResetPassword: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const { auth } = useRepositories();
  const token = new URLSearchParams(location.search).get('token') ?? '';

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError(null);

    if (!token) {
      setError('El enlace no es válido. Pedí uno nuevo desde "Olvidé mi contraseña".');
      return;
    }
    if (newPassword.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);
    try {
      await auth.resetPassword(token, newPassword);
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo restablecer la contraseña.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <IonPage>
      <IonContent fullscreen className="login-content">
        <div className="login-container">
          <div className="login-logo">
            <BrandMark />
            <h1>DomIoT</h1>
            <p>Elegir nueva contraseña</p>
          </div>

          {done ? (
            <>
              <IonText>
                <p style={{ textAlign: 'center', fontSize: 14, lineHeight: 1.6 }}>
                  Listo, tu contraseña se actualizó correctamente.
                </p>
              </IonText>
              <IonButton expand="block" onClick={() => history.replace('/login')}>
                Ir a iniciar sesión
              </IonButton>
            </>
          ) : !token ? (
            <>
              <IonText color="danger">
                <p style={{ textAlign: 'center', fontSize: 14 }}>
                  Este enlace no es válido o ya fue usado. Pedí uno nuevo.
                </p>
              </IonText>
              <IonButton expand="block" fill="clear" routerLink="/forgot-password">
                Pedir un enlace nuevo
              </IonButton>
            </>
          ) : (
            <>
              <PasswordInput placeholder="Contraseña nueva" value={newPassword} onValueChange={setNewPassword} />
              <PasswordInput
                placeholder="Repetir contraseña nueva"
                value={confirmPassword}
                onValueChange={setConfirmPassword}
                onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
              />

              {error && (
                <IonText color="danger">
                  <p className="login-error">{error}</p>
                </IonText>
              )}

              <IonButton expand="block" onClick={handleSubmit} disabled={loading}>
                {loading ? 'Guardando...' : 'Guardar nueva contraseña'}
              </IonButton>
            </>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ResetPassword;
